import React, { useEffect, useRef, useState } from "react";
import { connect } from 'react-redux'
import styles from './InfoHeader.module.scss'
import StackIcon from "../../components/StackIconsHelper";
import { DEBUG } from "../../settings/global";
import * as config from "../../settings/global";
import Button from "../../components/ripple/Button";
import { useRouter } from "next/router";
import { generateSlug } from "../../helpers/common";
import { NAV_STACK_LIST } from "../../settings/navigation";

function InfoHeader({stack, clouds, width}) {
    
    const router = useRouter();
    const [open, setOpen] = useState(false);
    const list = useRef();
    let trigger = null;

    const handleClickOutsideCloudList = e => {

        const clickedInside = list.current?.contains(e.target);
        const buttonClicked = !trigger || trigger?.contains(e.target);

        if (!clickedInside && !buttonClicked) setOpen(false);
    };

    useEffect(() => {
        return () => {
            document.removeEventListener('mousedown', handleClickOutsideCloudList)
        }
    }, []);
    
    useEffect(() => {
        if (open) document.addEventListener('mousedown', handleClickOutsideCloudList);
        if (!open) {
            document.removeEventListener('mousedown', handleClickOutsideCloudList);
        }
    }, [open]);

    useEffect(() => {
        if (router.isReady) {
            const toTopButton = document.getElementsByClassName('button-scroll-top')?.[0];

            if (!!open && width <= 700) {
                if (toTopButton) toTopButton.style.display = 'none'; // to top button can block content and is irrelevant when modal is open
                document.body.style.overflow = 'hidden'; // prevent back content from scrolling
            } else {
                if (toTopButton && toTopButton.style.display !== 'flex') toTopButton.style.display = 'flex';
                if (document.body.style.overflow !== 'auto') document.body.style.overflow = 'auto';
            }
        }
    }, [width, router]);

    const renderCloudList = () => {

        return clouds.map(cloud => {

            const link = NAV_STACK_LIST + '/' + generateSlug(stack.name) + '/' + generateSlug(cloud.name);
            let icon = null;
            let title = undefined;

            if (!!config.DEBUG && (!!cloud.lock || !cloud['impl'])) {
                icon = `fas fa-${!!cloud.lock ? "code" : "angle-double-up"}`;
                title = !!cloud.lock ? 'Maintained' : 'Coming soon';
            }

            if (!!config.DEBUG && !!stack?.clouds?.length && !stack.clouds.includes(cloud.code)) {
                icon = 'fas fa-eye-slash';
                title = 'Not supported by stack';
            }

            return (
                <a href={link} draggable='false' title={title} key={cloud.code}>
                    <Button
                        className={styles['dropdown__list__container__button']}
                        title={cloud.name}
                        displayType='text'
                        iconRight={icon}
                        visuals={{
                            colorBasic: ['var(--colorFontCommon)'],
                            borderRadius: '0',
                        }}
                    />
                </a>
            )
        });
    };

    const renderDropdown = () => {

        const showCloudList = open ? ` ${styles['dropdown--open']}` : '';
        const locked = !DEBUG && (!!stack.accessibility.comingSoon || !!stack.accessibility.hidden);

        return (
            <div className={`${styles['dropdown']}${showCloudList}`}>
                <Button
                    className={styles['dropdown__button']}
                    onClick={() => setOpen(!open)}
                    title={locked ? `Coming soon` : `Deploy to`}
                    iconRight={locked ? `fas fa-lock` : `fas fa-chevron-down`}
                    visuals={{
                        // colorBasic: ['var(--colorFontSuccess)'],
                        height: '5rem',
                        width: '20rem'
                    }}
                    disabled={locked}
                    passedRef={el => trigger = el}
                />
                <div className={styles['dropdown__list']}>
                    <div className={styles['dropdown__list__container']} ref={list}>
                        {renderCloudList()}
                    </div>
                </div>
            </div>
        )
    }
    
    return (
        <div className={styles['header']}>
            <div className={styles['header__icon']}>
                <StackIcon
                    icon={stack.icon}
                    code={stack.code}
                    name={stack.name}
                    // plan={stack.plan}
                    className={styles['header__icon__item']}
                    // height={90}
                    // width={90}
                />
            </div>
            <div className={styles['header__app']}><h1>{stack.name}</h1></div>
            <div className={styles['header__dropdown']}>
                {renderDropdown()}
            </div>
        </div>
    )
}

const mapStateToProps = state => ({
    width: state.UI.layoutDimensions.width,
});

export default connect(mapStateToProps)(InfoHeader)